import AdvisorPayouts from '@/components/global-admin/AdvisorPayouts';

export default function PayoutsPage() {
  return (
    <div className="space-y-6 p-6" data-testid="payouts-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Advisor payouts</h1>
        <p className="text-muted-foreground">Advisors invoice BitSwan for what their clients have paid.</p>
      </div>
      <AdvisorPayouts />
    </div>
  );
}
